import RestUseCase from "./RestUseCase";

export function restUseCase() {
  return new RestUseCase();
}
